import styled from 'styled-components';
import { useTranslation } from 'i18n';

const MembershipBadgeContainer = styled.div<{ $isActive: boolean }>`
  width: fit-content;
  display: flex;
  gap: 4px;
  font-size: 12px;
  font-weight: 800;
  font-style: italic;
  line-height: 20px;
  letter-spacing: 0.2px;
  background-color: ${(props) => (props.$isActive ? '#002400' : '#EAEBEF')};
  border-radius: 4px;
  padding: 4px 8px;
`;

const TypeText = styled.span<{ $isActive: boolean }>`
  color: ${(props) => (props.$isActive ? '#d4ea2f' : '#B6BCBF')};
`;

const PassText = styled.span<{ $isActive: boolean }>`
  color: ${(props) => (props.$isActive ? '#fff' : '#B6BCBF')};
`;

const translateText = (text: string) => {
  if (!text) return '';

  const s = text.trim();

  return s[0].toUpperCase() + s.slice(1).toLowerCase();
};

export const MembershipBadge = ({
  text,
  isActive = true,
}: {
  text: string;
  isActive?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <MembershipBadgeContainer $isActive={isActive}>
      <TypeText $isActive={isActive}>{translateText(text)}</TypeText>
      <PassText $isActive={isActive}>{t('membership.info.pass')}</PassText>
    </MembershipBadgeContainer>
  );
};
